// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"_1H-AD","effectsGrayscale30":"_1hHH5","resetList":"_3mCPa","image":"_1G-a5","loaded":"_2d1iO"};